<template>
  <div>
    <div class="fontMono">
      <div>
        <div class="table-container">
          <table class="table is-bordered is-narrow">
            <tr>
              <td colspan="6" style="padding-bottom: 0px; padding-top: 0px;">
                <h2 class="title">
                  {{empresa.nombrec}}
                  <small
                    class="title is-4 has-text-grey"
                  >Nit: {{empresa.nit | textnumber()}}{{empresa.nit | dverif()}}</small>
                </h2>
                <h2 class="subtitle is-6">{{empresa.nombre}}</h2>
              </td>
              <td colspan="4" class="has-text-right">
                <h2 class="title is-3">
                  {{data.comprobante.prefijo}}
                  {{registros[0].documento}}
                </h2>
              </td>
            </tr>
            <tr>
              <td colspan="11">{{empresa.ciudad}} {{empresa.direccion}} Tel: {{empresa.telefono}}</td>
            </tr>
            <tr>
              <td colspan="6">
                <h3
                  class="title is-capitalized"
                >{{data.comprobante.titulo ? data.comprobante.titulo : data.comprobante.nombre}}</h3>
              </td>
              <td colspan="4" style="padding-bottom: 0px; padding-top: 0px;" class="has-text-right">
                <h3
                  class="title is-4"
                  style="padding-top: 1px; margin-top: 5px"
                >{{registros[0].fecha | date()}}</h3>
              </td>
            </tr>
            <tr class="has-background-light">
              <th>Cuenta</th>
              <th>Nit</th>
              <th>Descripción</th>
              <th>Ref</th>
              <th>CC</th>
              <th>Producto</th>
              <th>Cant</th>
              <th>$</th>
              <th>Bod</th>
              <th>Valor</th>
            </tr>
            <tr v-for="(registro, index) in registros" :key="index" :style="isbold(registro)">
              <td :class="{ 'has-background-light':  registro.esTotal}">
                <small>{{registro.idcuenta.codigo}} {{registro.idcuenta.nombre}}</small>
              </td>
              <td :class="{ 'has-background-light':  registro.esTotal}">
                <small>
                  {{registro.idnit.nombre == 'NA' ? '' : registro.idnit.nombre}}
                  {{registro.idnit.nombre == 'NA' ? '' : registro.idnit.codigo}}
                </small>
              </td>
              <td :class="{ 'has-background-light':  registro.esTotal}">
                <small>{{registro.descripcion}}</small>
              </td>
              <td :class="{ 'has-background-light':  registro.esTotal}">{{registro.docRef}}</td>
              <td :class="{ 'has-background-light':  registro.esTotal}">{{registro.ccostos}}</td>
              <td :class="{ 'has-background-light':  registro.esTotal}">
                <small>
                  <strong>{{registro.producto ? registro.producto.codigo : ''}}</strong>
                  {{registro.producto ? registro.producto.descripcion : ''}}
                  {{registro.producto ? registro.producto.marca : ''}}
                </small>
              </td>
              <td :class="{ 'has-background-light':  registro.esTotal}">{{registro.cantidad}}</td>
              <td :class="{ 'has-background-light':  registro.esTotal}">{{registro.vlrUnitario}}</td>
              <td :class="{ 'has-background-light':  registro.esTotal}">
                <small>{{registro.bodega ? registro.bodega.codigo: ''}} {{registro.bodega ? registro.bodega.descripcion : ''}}</small>
              </td>
              <td
                class="has-text-right"
                :class="{ 'has-background-light':  registro.esTotal}"
              >{{data.comprobante.tipo == registro.tipo && !registro.esTotal ? '-' : ''}}{{registro.valor | number(2)}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div>
        Firma y Sello del Beneficiario
        <br />
        <br />
        <br />
        <br />________________________________
        <br />C.C.
        <br />
        <br />
        {{data.comprobante.mensaje}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    data: Object,
    registros: Array,
  },
  computed: {
    ...mapState(["empresa"]),
  },
  methods: {
    isbold(field) {
      if (field.esTotal) {
        return {
          "font-weight": "bold",
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/prints/Printinventario.vue